import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/Interface/Button/Button";
import { LandingBlob } from "@/components/Welcome/LandingBlob/LandingBlob";
import { useAnonymousLogin } from "@/hooks/useAnonymousLogin";

export const WelcomeEsimContent = () => {
  const { t } = useTranslation();
  const loginAsAnonymous = useAnonymousLogin();
  const navigate = useNavigate();

  return (
    <LandingBlob>
      <div id="text-and-buttons">
        <h1 className="mb-6 mt-[17rem] text-secondary-100 md:mt-12">
          {t("EsimLanding.title")}
        </h1>

        <p className="mb-10 max-w-[600px]">{t("EsimLanding.description")}</p>

        <div className="flex w-full flex-col gap-4 md:w-fit md:flex-row md:gap-6 smPlus:w-fit">
          <Button
            className="min-w-full md:min-w-fit"
            onClick={loginAsAnonymous}
          >
            {t("EsimLanding.eSimJourneyButton")}
          </Button>
          <Button
            className="reverse-primary"
            onClick={() => {
              navigate("/welcome");
            }}
          >
            {t("EsimLanding.portalButton")}
          </Button>
        </div>
      </div>

      <p className="mt-10 text-base md:mt-20">
        {t("EsimLanding.identificationHint")}
      </p>
    </LandingBlob>
  );
};
